import { put, putResolve, call } from 'redux-saga/effects'

import { REQUEST } from '@piconetworks/network-middleware'
import { PICO_API_URL, PROMPT_METRICS } from '@piconetworks/endpoints'

import { creators } from '../actions'

export default function* sendMessage({ payload }) {
    const {
        promptType,
        triggerId,
        articleId,
        endpoint = PROMPT_METRICS(),
    } = payload

    try {
        const response = yield putResolve({
            type: REQUEST,
            config: {
                method: 'post',
                baseURL: PICO_API_URL(),
                url: endpoint,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                timeout: 30000,
                data: {
                    prompt_type: promptType.includes('signup') ? 'login' : 'purchase',
                    trigger_id: triggerId,
                    article_id: articleId,
                },
            },
        })

        yield put(
            yield call(creators.sendMessageSuccess, { payload: response }),
        )
    } catch (error) {
        yield put(
            yield call(creators.sendMessageError, { payload: error }),
        )
    }
}
